module.exports = __webpack_public_path__ + "static/img/modulo_bluetooth_at_09-1.57721b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/modulo_bluetooth_at_09-1.svg
// module id = XZq4
// module chunks = 0